import React, { Component } from 'react';
import styled from 'styled-components';

const Prefixes = styled.div`
	position: absolute;
	top: 5px;
	left: 5px;
	fontWeight: bold;
	fontSize: 1.1rem;
`;

const Postfix = styled.div`
	position: absolute;
	top: 5px;
	right: 5px;
	font-weight: bold;
	font-size: 1.1rem;
`;

const Wrapper = styled.div`
  input {
		font-size: 1em;
		font-family: GothamLight! important;
    &:focus {
      outline: none;
    }
  }
	.form-control-custom {
      display: block;
      padding-left: 10px;
      width: calc(100% - 12px);
      padding: 6px 0;
      font-size: 14px;
      line-height: 1.42857143;
      color: #555;
      background-color: #fff;
      background-image: none;
      border: 1px solid #575757;
      border-radius: .5em;
      height: 30px;
      box-shadow: inset 0 1px 1px rgba(0,0,0,.075);
      transition: border-color ease-in-out .15s,box-shadow ease-in-out .15s;
	}
`;

class TextInput extends Component {

  componentDidMount() {
  	if (this.props.min) {
			this.input.value = this.props.value || this.props.min;
		}
  }

	componentWillReceiveProps(nextProps) {
  	if (this.props.value !== nextProps.value) {
			this.input.value = nextProps.value || '';
		}
	}

  componentWillMount() {
		if (this.props.value === 0 || this.props.value === '') {
			setTimeout(() => this.props.onChange(this.props.min), 500);
		}
	}

  handleKeyPress = (e) => {
    if (e.which === 13 && typeof this.props.onEnter === 'function') {
      this.props.onEnter();
    }
    if (e.which === 27 && typeof this.props.onEsc === 'function') {
      this.props.onEsc();
    }
  };

  onChange = (e) => {
		this.props.onChange(e.target.value);
	};

  render() {
    const { prefixes, postfix, style, min, max, width, children, id, name, maxLength, readOnly, placeholder, type } = this.props;
    const inputStyle = {
			...style,
			paddingLeft: prefixes ? '20px' : '10px',
			paddingRight: postfix ? '20px' : 'undefined',
		};
    return (
      <Wrapper style={{ width }} >
        <div style={{ position: 'relative', width }} >
          {prefixes && <Prefixes>{prefixes}</Prefixes>}
          <input
						{...{
              id,
              name,
							maxLength,
							readOnly,
							placeholder,
							style: inputStyle,
							type: type || 'text',
							min,
							max,
							ref: input => (this.input = input),
							onChange: this.onChange,
							onKeyPress: this.handleKeyPress,
							className: 'form-control-custom'
						}}
          />
          {postfix ? <Postfix>{postfix}</Postfix> : ''}
        </div>
        {children && <div className='block-input__value-format-tip' >{children}</div>}
      </Wrapper>
    );
  }
}

export default TextInput;



// WEBPACK FOOTER //
// ./src/html/controls/TextInput.js